import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { EnterPhoneNumberPage } from './enter-phone-number.page';

const routes: Routes = [
  {
    path: '',
    component: EnterPhoneNumberPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EnterPhoneNumberPage]
})
export class EnterPhoneNumberPageModule {}
